import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Bestelldetails',
  sections: {
    driver_info: 'Fahrer-Info',
    order_info: 'Bestell details',
    price_info: 'Preis details',
    adjustments: 'Anpassungen',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'Abholung',
    [ORDER_METHODS.delivery]: 'Lieferung',
    [ORDER_METHODS.on_site]: 'Tischbestellung',
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: 'Diese Bestellung ist noch nicht genehmigt',
    [FULFILLMENT_STATUSES.reviewed]: 'Diese Bestellung wartet auf Bestätigung',
    [FULFILLMENT_STATUSES.accepted]: 'Diese Bestellung wird derzeit bearbeitet',
    [FULFILLMENT_STATUSES.preparing]: 'Diese Bestellung wird derzeit bearbeitet',
    [FULFILLMENT_STATUSES.ready]: 'Diese Bestellung ist bereit zur Abholung durch den Kunden',
    [FULFILLMENT_STATUSES.on_delivery]: 'Diese Bestellung wird an den Kunden geliefert',
    [FULFILLMENT_STATUSES.picked]: 'Diese Bestellung wurde erfolgreich ausgeführt',
    [FULFILLMENT_STATUSES.rejected]: 'Diese Bestellung wurde abgelehnt und zurückerstattet',
    default: 'Diese Bestellung wurde erfolgreich ausgeführt',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Vom Kunden gewünscht',
    [REFUND_REASONS.Reclamation]: 'Reklamation',
    [REFUND_REASONS.CommunicationError]: 'Kommunikationsfehler',
    [REFUND_REASONS.Other]: 'Andere',
    [REFUND_REASONS.Dispute]: 'Kundenstreit',
    dispute_win: 'Gewonnener Kundenstreit',
    null: '',
    undefined: '',
  },
  labels: {
    // A table order's table: "Table 7"; names like "Terrace 2" show as they are.
    table_numbered: 'Tisch {{name}}',
    // Orders placed with Room/Table service before table ordering: the venue and the number typed.
    venue: 'Standort',
    table_number: 'Tischnummer',
    order_note: 'Anmerkung zur Bestellung',
    discount: 'Rabatt',
    driver_name: 'Name des Fahrers',
    driver_phone_number: 'Telefon des Fahrers',
    pin_code: 'PIN',
    invoice_payment: 'Zahlung auf Rechnung',
    paid_in_cash: 'Zahlung in Bar',
    customer_paid_online: 'Kunde hat online bezahlt',
    phone: 'Tel',
    email: 'E-Mail',
    points_used: 'Diese Bestellung enthält eine eingelöste Treuepunkt-Prämie von einem loyalen Kunden.',
    delivery: 'Lieferung',
    pickup: 'Abholung',
    original: 'Original',
    delivery_fee: 'Liefergebühr',
    tip: 'Trinkgeld',
    service_fee: 'Online-Zuschlag',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'PayPal Gebühr',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: '% Rabatt gesamt',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: '% Rabatt Produkte',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Rabatt Produkte',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Rabatt gesamt',
      [OFFER_KIND.BOGO]: '2 für 1',
      [OFFER_KIND.BOGO_HALF_PRICE]: '2 für 1 (halb)',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Gratis Produkt',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Gratis gesamt',
      GiftCard: 'Gutschein',
      Reward: 'Punkte',
      CashbackAccount: 'Punkte',
      PromoCodeComponent: 'Promo',
      Offer: 'Angebot',
    },
    total_discount: 'Promo angewendet',
    tax: 'Taxes',
    total: 'Gesamt',
    today: 'Heute',
  },
  schedule: {
    header: 'Geplant für {{date}}, {{time}}',
    text: 'Wir werden Sie daran erinnern, wenn es an der Zeit ist, die Bestellung vorzubereiten.',
  },
};
